import React, {useMemo } from "react";

import { Trans } from "react-i18next";
import {
  Col,
  Row,
  Table,
} from "reactstrap";
import {
  CurrencySymbol,
  SpanColor,
  cStyle,
  calculateTax,
  formatCurrency,
  formatDate,
} from "services/util";
import FormGroup from "../EmailTemplates/FormGroup";
import { getTax } from "components/common/getStatus";
import LoadingMsg from "components/common/LoadingMsg";

export const TrackingSelect = ({
  lineItem,
  trackingCategory,
}) => {
  const { Tracking } = lineItem;

  const selectedTracking = useMemo(() => {
    return (
      Tracking?.reduce((acc, i) => {
        acc[i.Name] = i.Option;
        return acc;
      }, {}) ?? {}
    );
  }, [Tracking]);

  const selectedOption = selectedTracking[trackingCategory.Name] ?? null;

  const displayValue = selectedOption !== null ? selectedOption : '-';

  return (
    <span style={{ color: '#525F7F' }}>{displayValue}</span>
  );
};

export const ManualJournalsView = ({data, trackingCategories, accounts, organisation, taxRates, fields, t}) => {

  return (
    <div>
      {data?.ManualJournalID ?
        <>
          <Row>
            <Col {...cStyle.common}>
              <FormGroup label="Narration">
                <SpanColor>{data?.Narration || "---"}</SpanColor>
              </FormGroup>
            </Col>
            <Col {...cStyle.common}>
              <FormGroup label="Date">
                <SpanColor>{formatDate(data?.Date) || "---"}</SpanColor>
              </FormGroup>
            </Col>
            <Col {...cStyle.common}>
              <FormGroup label="Line Amount Types">
                <SpanColor>{getTax(data?.LineAmountTypes) || "---"}</SpanColor>
              </FormGroup>
            </Col>
            <Col {...cStyle.common}>
              <FormGroup label="Status">
                <SpanColor>{data?.Status || "---"}</SpanColor>
              </FormGroup>
            </Col>
          </Row>
          <div className="my-1"/>
          <hr />
          <Table className="mt-3" size="sm">
          <thead>
              <tr>
                <th className="text-left">
                  <Trans>Description</Trans>
                </th>
                <th className="text-left">
                  <Trans>Account</Trans>
                </th>
                <th className="text-left">
                  <Trans>Tax Rate</Trans>
                </th>
                {trackingCategories?.map((i) => (
                  <th key={i.TrackingCategoryID}><Trans>{i.Name}</Trans></th>
                ))}
                 <th>
                  <Trans>Debit</Trans> <Trans><CurrencySymbol currency={organisation?.BaseCurrency}/></Trans>
                </th>
                <th>
                  <Trans>Credit</Trans> <Trans><CurrencySymbol currency={organisation?.BaseCurrency}/></Trans>
                </th>
              </tr>
            </thead>
            <tbody>
              {fields?.map((i, idx) => {
                const accountName = accounts?.length > 0 && accounts?.find(option => option.Code === i.AccountCode)?.Name
                const taxName = taxRates?.length > 0 && taxRates?.find(option => option.TaxType === i.TaxType)
                const credit = i.LineAmount < 0 ? (-1 * i.LineAmount) : "-";
                const debit = i.LineAmount >= 0 ? i.LineAmount : "-" 
                return (
                  <tr key={i.key}>
                    <td className="text-left">{i.Description}</td> 
                    <td className="text-left">{i.AccountCode}{accountName && <> - <span style={{ color: '#525F7F' }}>{accountName}</span></>} </td>
                    <td className="text-left">{taxName.Name}</td>
                    {trackingCategories?.map((j) => (
                      <td key={j.TrackingCategoryID}>
                        <Trans>
                        <TrackingSelect
                          lineItem={i}
                          trackingCategory={j}
                          lineItemIndex={idx}
                          disabled
                        />
                        </Trans>
                      </td>
                    ))}
                    <td>{debit > 0 ? formatCurrency(debit) : debit}</td>
                    <td>{credit > 0 ? formatCurrency(credit) : credit}</td>
                  </tr>
                );
              })}
            </tbody>
          </Table>
        </> : <div className="mt-3"><LoadingMsg/></div>
        }
    </div>
  );
};
